const SortArrow = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 48 48">
      {/* <title>arrow-sort-solid</title> */}
      <g id="Layer_2" data-name="Layer 2">
        <g id="invisible_box" data-name="invisible box">
          <rect width="48" height="48" fill="none" />
        </g>
        <g id="Q3_icons" data-name="Q3 icons">
          <path d="M24,39.2,13.4,28.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,0,0,0,.2,2.7l12,11.9a1.9,1.9,0,0,0,2.8,0l12-11.9a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,0,0,0-3-.2Z" />
          <path d="M24,8.8,34.6,19.4a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7L25.4,4.6a1.9,1.9,0,0,0-2.8,0l-12,11.9a2.1,2.1,0,0,0-.2,2.7,1.9,1.9,0,0,0,3,.2Z" />
        </g>
      </g>
    </svg>
  );
}

export default SortArrow;
